<template>
  <div class="period-select">
    <el-radio-group :value="periodValue" @input="handleChangePeriod">
      <el-radio-button v-for="period in periods" :key="period" :label="period">{{ periodsOptions[period].label }}</el-radio-button>
    </el-radio-group>
    <el-date-picker
      :value="dateValue"
      :type="datePickerType"
      placeholder="选择日期"
      value-format="yyyy-MM-dd"
      :format="periodsOptions[periodValue].format"
      :picker-options="pickerOptions"
      :editable="false"
      :clearable="false"
      @input="handleChangeDate"
    />
  </div>
</template>

<script>
import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class PeriodSelect extends Vue {
  @Prop({ type: Array, default: () => ['week', 'month', 'year'] }) periods; // ['week', 'month', 'year']
  @PropSync('period', { type: String }) periodValue;
  @PropSync('date', { type: String }) dateValue;

  get datePickerType() {
    return this.periodValue === 'day' ? 'date' : this.periodValue;
  }

  periodsOptions = {
    day: {
      label: '日报',
      format: 'yyyy-MM-dd',
    },
    week: {
      label: '周报',
      format: 'yyyy 第 WW 周',
    },
    month: {
      label: '月报',
      format: 'yyyy-MM',
    },
    year: {
      label: '年报',
      format: 'yyyy',
    },
  }

  pickerOptions = {
    firstDayOfWeek: 1,
    disabledDate: (time) => {
      return time.getTime() > Date.now();
    }
  }

  handleChangePeriod(period) {
    if (period === 'year') {
      this.dateValue = moment().startOf('year').format('YYYY-MM-DD');
    } else if (period === 'month') {
      this.dateValue = moment().startOf('month').format('YYYY-MM-DD');
    } else if (period === 'week') {
      this.dateValue = moment().startOf('isoWeek').format('YYYY-MM-DD');
    } else {
      this.dateValue = moment().format('YYYY-MM-DD');
    }
    this.periodValue = period;
  }

  handleChangeDate(date) {
    if (this.periodValue === 'week') {
      // elementui 好像有bug 总是会延后一天
      this.dateValue = moment(date).startOf('isoWeek').format('YYYY-MM-DD');
    } else {
      this.dateValue = date;
    }
  }
}
</script>

<style lang="scss" scoped>
.period-select {
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
